// extracted by mini-css-extract-plugin
export default {"page":"OperationRecord_page__CaCUV","statusTag":"OperationRecord_statusTag__LYGao","viewButton":"OperationRecord_viewButton__aG1gi"};